import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { I18n, Translate } from 'react-redux-i18n';
import './index.scss';
import { FACheckUpPDFUrl } from '../../../../../configs/ContactConfig';
import BarChart from '../../common/bar-chart';
import { fetchZMFScore, REDUCER_NAME } from '../../reducer';
import { Responsive } from './../../../../common/responsive';
import { withComponentId } from '../../../../common/ComponentIdContext';

const Z_CHART = 'Z-SCORE';
const M_CHART = 'M-SCORE';
const F_CHART = 'F-SCORE';

const GREEN = '#37a77d';
const RED = '#eb505a';
const YELLOW = '#facc5c';

const Z_TOOLTIP = (
  <div className="d-flex flex-column align-items-start">
    <div>
      <Translate value={`financialAnalysis.zTooltip.firstRow`} />
    </div>
    <div>
      <Translate value={`financialAnalysis.zTooltip.secondRow`} />
    </div>
  </div>
);
const M_TOOLTIP = (
  <div className="d-flex flex-column align-items-start">
    <div>
      <Translate value={`financialAnalysis.mTooltip.firstRow`} />
    </div>
    <div>
      <Translate value={`financialAnalysis.mTooltip.secondRow`} />
    </div>
  </div>
);
const F_TOOLTIP = (
  <div className="d-flex flex-column align-items-start">
    <div>
      <Translate value={`financialAnalysis.fTooltip.firstRow`} />
    </div>
  </div>
);

class ZMFScore extends React.Component {
  getFillFunction = typeChart => {
    const fillZ = (d, i) => {
      if (d.x < 1.8) return RED;
      if (d.x >= 1.8 && d.x <= 2.9) return YELLOW;
      if (d.x > 2.9) return GREEN;
    };

    const fillM = (d, i) => {
      if (d.x < -2.22) return GREEN;
      if (d.x >= -2.22) return RED;
    };

    const fillF = (d, i) => {
      if (d.x <= 2) return RED;
      if (d.x >= 6) return GREEN;
      return YELLOW;
    };

    if (typeChart === Z_CHART) {
      return fillZ;
    }
    if (typeChart === M_CHART) {
      return fillM;
    }

    return fillF;
  };

  componentDidMount() {
    const { fetchZMFScore, searchParams, componentId } = this.props;
    const query = Object.keys(searchParams).length
      ? { OrganCode: searchParams.code }
      : { OrganCode: 'AAA' };
    fetchZMFScore(componentId, query);
  }

  render() {
    const {
      component,
      ZMFScoreData: { zData = [], mData = [], fData = [], isLoading = true },
    } = this.props;

    return (
      <div className="ZMF-score-wrapper" id="zmf-content-export">
        <Responsive component={component} margin={20} offsetWidth={40}>
          {width => (
            <BarChart
              toolTip={Z_TOOLTIP}
              fill={this.getFillFunction(Z_CHART)}
              title="Z-SCORE"
              isLoading={isLoading}
              data={zData}
              width={width}
            />
          )}
          {width => (
            <BarChart
              toolTip={M_TOOLTIP}
              fill={this.getFillFunction(M_CHART)}
              title="M-SCORE"
              isLoading={isLoading}
              data={mData}
              width={width}
            />
          )}
          {width => (
            <BarChart
              toolTip={F_TOOLTIP}
              fill={this.getFillFunction(F_CHART)}
              title="F-SCORE"
              isLoading={isLoading}
              data={fData}
              width={width}
            />
          )}
        </Responsive>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    component: state[REDUCER_NAME].listMultiComponent[componentId].component,
    ZMFScoreData:
      state[REDUCER_NAME].listMultiComponent[componentId].ZMFScoreData,
    searchParams:
      state[REDUCER_NAME].listMultiComponent[componentId].searchParams,
  };
};

const mapDispatchToProps = {
  fetchZMFScore,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ZMFScore);
